<div>
    <div class="root  ">
      <div class="container">
        <div>
          <div class="number">
            4
          </div>
          <div class="number">
            0
          </div>
          <div class="number">
            3
          </div>
        </div>
        <div class="description">
          {{'ForbbidenPage.DescriptionText' | translate}}
        </div>
        <div
          class="sectionInfo">
          <div>
            <div class="descriptionError">
              {{'ForbbidenPage.DescriptionErrorText' | translate}}
            </div>
          </div>
          <div>
            <p-button label="Home" (onClick)="redirect()"></p-button>
          </div>
        </div>
      </div>
      <div class="footer-logo">
        <img src="../../../../assets/img/fruzty-logo-slogan.png" width="250" height="111" alt=""/>
      </div>
    </div>
  </div>
